import React, { useRef, useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { transImageSrc } from 'base/utils/trans-path';
import Image from '@base/lib/ThemeImage';
import { loadImage } from 'base/utils/getPicUrl'

interface IProps {
    aspectRatio?: number;
    imgShowWidth?: number;
    imgBigWidth?: number;
    imgUrl: string;
    alt?: string;
    hoverImgUrl?: string;
    bigPicRef?: React.RefObject<HTMLDivElement>;
}

const ImageZoomViewer: React.FC<IProps> = (props) => {
    const [isWiderImg, setIsWiderImg ] = useState<boolean>(true)
    const {
        aspectRatio = 1,
        imgShowWidth = 555, // imgShowWidth的值影响加车动画中的图片，需要同步修改
        imgBigWidth = 750,
        imgUrl = '',
        alt = '',
        hoverImgUrl = '',
        bigPicRef
    } = props

    const imgBoxRef = useRef<HTMLDivElement>(null)
    const imgSmallSelfRef = useRef<HTMLDivElement>(null)
    const imgSmallRef = bigPicRef || imgSmallSelfRef;
    const imgMaskRef = useRef<HTMLDivElement>(null)
    const imgBigImgRef = useRef<HTMLImageElement>(null)

    const onMouseMoveHandle = (event: React.MouseEvent<HTMLDivElement>) => {
        const imgBox = imgBoxRef?.current as HTMLDivElement
        const imageSmall = imgSmallRef?.current as HTMLDivElement
        const imageMask = imgMaskRef?.current as HTMLDivElement
        const imageBigImg = imgBigImgRef?.current as HTMLDivElement

        // 获取鼠标在页面中的位置
        let pageX = event?.pageX;
        let pageY = event?.pageY;

        // 滚动距离
        let scrollX = document.body.scrollLeft || document.documentElement.scrollLeft
        let scrollY = document.body.scrollTop || document.documentElement.scrollTop

        // 获取图片左上角在页面中的位置
        let imgBoxX = scrollX + imgBox?.getBoundingClientRect()?.left;
        let imgBoxY = scrollY + imgBox?.getBoundingClientRect()?.top;
        let x = pageX - imgBoxX;
        let y = pageY - imgBoxY;

        // 移动mask, 必须知道鼠标在small中的位置.
        // 让鼠标在mask盒子最中间，减去mask盒子宽高的一半
        let maskX = x - imageMask.offsetWidth / 2;
        let maskY = y - imageMask.offsetHeight / 2;

        //限制换盒子范围
        //left取值为大于0，小盒子的宽 - mask的宽。
        if (maskX < 0) {
            maskX = 0;
        }
        if (maskX > imageSmall.offsetWidth - imageMask.offsetWidth) {
            maskX = imageSmall.offsetWidth - imageMask.offsetWidth;
        }
        if (maskY < 0) {
            maskY = 0;
        }
        if (maskY > imageSmall.offsetHeight - imageMask.offsetHeight) {
            maskY = imageSmall.offsetHeight - imageMask.offsetHeight;
        }

        //移动mask
        imageMask.style.left = maskX + "px";
        imageMask.style.top = maskY + "px";

        // 右侧的大图片, 等比例移动。
        // 大图片走的距离 / mask走的距离 = 大图片/小图片
        let ratio = imageBigImg.offsetWidth / imageSmall.offsetWidth;

        let imgX = ratio * maskX;
        let imgY = ratio * maskY;

        // imageBigImg.style.marginTop = -imgY + "px";
        // imageBigImg.style.marginLeft = -imgX + "px";
        imageBigImg.style.transform = `translateX(${-imgX}px) translateY(${-imgY}px)`
    }

    const loadImgHandle = () => {
        loadImage(transImageSrc(imgUrl, imgShowWidth, 1), (img)=> {
            let width = img.width;
            let height = img.height;
            // 获取图片宽高比
            const _isWiderImg = img.height / img.width < aspectRatio
            setIsWiderImg(_isWiderImg)
        })
    }

    useEffect(()=> {
        loadImgHandle()
    }, [imgUrl])

    return (
        <div className={styles['image-viewer-wrap']}>
            <div
                ref={imgBoxRef}
                className={cn(
                    styles.imgBox,
                    [isWiderImg ? styles['width-type'] : styles['height-type'] ],
                    'relative'
                )}
                onMouseMove={onMouseMoveHandle}
            >
                <div ref={imgSmallRef} className={`${styles.small} relative`}>
                    <div className={'flex flex-justify flex-middle'}>
                        <Image
                            src={imgUrl}
                            alt={alt}
                            width={imgShowWidth}
                            height={imgShowWidth * aspectRatio}
                        />
                    </div>

                    <div ref={imgMaskRef} className={`${styles.mask} absolute`}/>
                </div>
                <div className={`${styles.big} absolute`}>
                    <Image
                        className={styles['img']}
                        ref={imgBigImgRef}
                        src={transImageSrc(hoverImgUrl || imgUrl, imgBigWidth, 1)}
                        alt={alt}
                        width={imgBigWidth}
                        fixed
                        background={false}
                    />
                </div>
            </div>
        </div>
    )
}

export default React.memo(ImageZoomViewer);
